// DS: i12.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioAnalytics: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.1025 3.00488C19.6067 3.05621 20 3.48232 20 4V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V4L4.00488 3.89746C4.05621 3.39333 4.48232 3 5 3H19L19.1025 3.00488ZM6 19H18V5H6V19ZM15.5352 8.80469C15.9888 8.85099 16.3428 9.23436 16.3428 9.7002V11.2002C16.3426 11.6971 15.9394 12.1006 15.4424 12.1006C15.1532 12.1004 14.896 11.9631 14.7314 11.751L12.6631 13.9238C12.2663 14.3401 11.6217 14.3772 11.1816 14.0264L11.0967 13.9512L10.6289 13.4932L8.96289 15.3086C8.62673 15.6743 8.05741 15.6991 7.69141 15.3633C7.3256 15.0273 7.30114 14.4579 7.63672 14.0918L9.79297 11.7432L9.875 11.6631C10.2732 11.3104 10.8708 11.2948 11.2871 11.626L11.373 11.7021L11.8486 12.168L13.417 10.5205C13.1036 10.3798 12.8849 10.0659 12.8848 9.7002C12.8848 9.20337 13.2874 8.80019 13.7842 8.7998H15.4424L15.5352 8.80469Z"
          fill="currentColor"
        />
      </svg>
    </IconWrap>
  );
};

export default StudioAnalytics;
